/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Trial_Days_LabelInputs */

const en_admin_invite_codes_trial_days_label = /** @type {(inputs: Admin_Invite_Codes_Trial_Days_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial days`)
};

/**
* | output |
* | --- |
* | "Trial days" |
*
* @param {Admin_Invite_Codes_Trial_Days_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_trial_days_label = /** @type {((inputs?: Admin_Invite_Codes_Trial_Days_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Trial_Days_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_trial_days_label(inputs)
});
export { admin_invite_codes_trial_days_label as "admin.invite_codes.trial_days_label" }